"use client";
import { useLocation } from 'react-router-dom';
import { useState, useRef } from "react";
import {
  Calendar,
  FileText,
  Clock,
  Gauge,
  Car,
  CreditCard,
  CheckCircle,
  X,
  User,
  Fuel,
  Key,
  FileCheck,
  ClipboardCheck,
  ArrowLeft,
  FileImage,
  X as XIcon,
} from "lucide-react";
import GreyArrow from "../assets/greyLeftAr.png";
import { format } from "date-fns";
import DashboardImage from "../assets/Pickuppreview.png";

import "./Css/PickupFormPreview.css";
import Header from "./Header";
import PickUpFormPDF from './PickUpFormPDF';
import { Button } from '@mui/material';
import { goBack } from '../CommonJquery/CommonJquery';
import Breadcrumb from '../CommonJquery/Breadcrumb';
export default function PickupFormPreview() {
  const location = useLocation();
  const data = location.state.option;
  const carData = data.car_data[0];
  const carimage = location.state.CarImgPath
  console.log('data',data)

  const [activeTab, setActiveTab] = useState("overview");

  // State for image preview modal
  const [previewImage, setPreviewImage] = useState(null);

  // Function to open image preview
  const openImagePreview = (imageUrl) => {
    setPreviewImage(imageUrl);
  };

  // Function to close image preview
  const closeImagePreview = () => {
    setPreviewImage(null);
  };
  const childRef = useRef();
  const [downloadForm, SetDownloadForm] = useState();
  const triggerDownloadPDF = (data) => {
    SetDownloadForm(data);
    setTimeout(() => {
      if (childRef.current) {
        childRef.current.handleDownloadPDF();
      }
    }, 100);
    // childRef.current.handleDownloadPDF();
  };
  return (
    <div>
      <Header />
      <div className="downLoad_PrintEnqury ">
        <PickUpFormPDF
          ref={childRef}
          downloadForm={downloadForm}
          carimage={carimage}
          carData={carData}
        />
      </div>
      <div className="container py-4">
        <div className='pageCntn_head p-0'>
          <div className="pageNameDiv ">
          <Breadcrumb
          items={[
            { label: "Bookings", path: "/Bookings" },
            {
            label: "Pick-up Form Details", path: "/PickupFormPreview"
            },
          ]}
          />
          </div>
          <Button
            onClick={goBack}
            startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
            className="Back_bttn_page"
          >
            Back
          </Button>
        </div>

        {/* Fixed tabs with horizontal scroll */}
        <div className="custom-tabs-container">
          <ul
            className="custom-tabs d-flex overflow-auto no-scrollbar"
            role="tablist"
          >
            <li className="custom-tab-item flex-shrink-0" role="presentation">
              <button
                className={`custom-tab-link ${activeTab === "overview" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("overview")}
              >
                <User className="tab-icon" />
                <span>Overview</span>
              </button>
            </li>
            <li className="custom-tab-item flex-shrink-0" role="presentation">
              <button
                className={`custom-tab-link ${activeTab === "vehicle" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("vehicle")}
              >
                <Car className="tab-icon" />
                <span>Vehicle Condition</span>
              </button>
            </li>
            <li className="custom-tab-item flex-shrink-0" role="presentation">
              <button
                className={`custom-tab-link ${activeTab === "documents" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("documents")}
              >
                <FileText className="tab-icon" />
                <span>Documents</span>
              </button>
            </li>
            <li className="custom-tab-item flex-shrink-0" role="presentation">
              <button
                className={`custom-tab-link ${activeTab === "final" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("final")}
              >
                <ClipboardCheck className="tab-icon" />
                <span>Final Checks</span>
              </button>
            </li>
          </ul>
        </div>

        <div className="tab-content mt-4" id="formTabsContent">
          {/* OVERVIEW TAB */}
          <div
            className={`tab-pane fade ${activeTab === "overview" ? "show active" : ""
              }`}
          >
            <div className="row g-4">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <User className="icon-sm me-2" />
                      Driver Information
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <div className="text-muted ">Full Name</div>
                        <div className="fw-medium">
                          {data?.first_name || "NA"} {data?.last_name || "NA"}
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <div className="text-muted ">Pickup Date</div>
                        <div className="fw-medium d-flex align-items-center">
                          <Calendar className="icon-sm me-2 text-muted" />
                          {format(data?.from_date, "MMMM d, yyyy")}
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <div className="text-muted ">Pickup Time</div>
                        <div className="fw-medium d-flex align-items-center">
                          <Clock className="icon-sm me-2 text-muted" />
                          {data?.from_time || "NA"}
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <div className="text-muted ">Insurance Type</div>
                        <div className="fw-medium d-flex align-items-center">
                          <FileCheck className="icon-sm me-2 text-muted" />
                          {data?.insurance || " NA"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <Car className="icon-sm me-2" />
                      Vehicle Information
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">
                      <div className="text-muted ">Car Details</div>
                      <div className="fw-medium">
                        {carData?.car_name || "NA"} / LP#:{" "}
                        {carData?.car_no}
                      </div>
                      <div className="small">
                        VIN#: {carData.vin} / Make Year:{" "}
                        {carData.make_year} / Model:{" "}
                        {carData.model_name}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <CreditCard className="icon-sm me-2" />
                      Payment & Agreement Status
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <div className="d-flex align-items-center">
                          {formData.agreementChecked ? (
                            <CheckCircle className="icon-sm me-2 text-success" />
                          ) : (
                            <X className="icon-sm me-2 text-danger" />
                          )}
                          <span>
                            Agreement{" "}
                            {formData.agreementChecked
                              ? "Received"
                              : "Not Received"}
                          </span>
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <div className="d-flex align-items-center">
                          {formData.paymentChecked ? (
                            <CheckCircle className="icon-sm me-2 text-success" />
                          ) : (
                            <X className="icon-sm me-2 text-danger" />
                          )}
                          <span>
                            Payment{" "}
                            {formData.paymentChecked
                              ? "Received"
                              : "Not Received"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>

          {/* VEHICLE CONDITION TAB */}
          <div
            className={`tab-pane fade ${activeTab === "vehicle" ? "show active" : ""
              }`}
          >
            <div className="row g-4">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <Gauge className="icon-sm me-2" />
                      Vehicle Readings
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <div className="text-muted ">Gas Level</div>
                        <div className="fw-medium d-flex align-items-center">
                          <Fuel className="icon-sm me-2 text-muted" />
                          {data?.pickup_gas_level || "NA"}
                        </div>
                      </div>

                      <div className="col-md-4 mb-3">
                        <div className="text-muted ">Odometer Reading</div>
                        <div className="fw-medium">
                          {data?.pickup_km || "NA"} miles

                        </div>
                      </div>

                      <div className="col-md-4 mb-3">
                        <div className="text-muted ">IPASS #</div>
                        <div className="fw-medium">{data?.ipass_number || "NA"}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <FileImage className="icon-sm me-2" />
                      Vehicle Images
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="mb-4">
                      <div className="text-muted  mb-2">
                        Dashboard (ODO & GAS)
                      </div>
                      <img
                        src={carimage + data.gas_and_odo_image || "/placeholder.svg"}
                        alt="Dashboard"
                        className="img-thumbnail dashboard-img cursor-pointer"
                        onClick={() =>
                          openImagePreview(carimage + data.gas_and_odo_image)
                        }
                      />
                    </div>

                    <hr />

                    <div className="mb-4">
                      <div className="text-muted  mb-2">Car Images</div>
                      <div className="car-images-container">
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <div className="car-image-card">
                              <div className="car-image-label">Driver Left</div>
                              <img
                                src={
                                  carimage + data.pickup_frontLeft ||
                                  "/placeholder.svg"
                                }
                                alt="Front Left View"
                                className="car-view-img cursor-pointer"
                                onClick={() =>
                                  openImagePreview(carimage + data.pickup_frontLeft)
                                }
                              />
                            </div>
                          </div>

                          <div className="col-md-6 mb-3">
                            <div className="car-image-card">
                              <div className="car-image-label">Driver Right</div>
                              <img
                                src={
                                  carimage + data.pickup_frontRight ||
                                  "/placeholder.svg"
                                }
                                alt="Front Right View"
                                className="car-view-img cursor-pointer"
                                onClick={() =>
                                  openImagePreview(
                                    carimage + data.pickup_frontRight
                                  )
                                }
                              />
                            </div>
                          </div>

                          <div className="col-md-6 mb-3">
                            <div className="car-image-card">
                              <div className="car-image-label">Passanger Left</div>
                              <img
                                src={
                                  carimage + data.pickup_backLeft ||
                                  "/placeholder.svg"
                                }
                                alt="Back Left View"
                                className="car-view-img cursor-pointer"
                                onClick={() =>
                                  openImagePreview(carimage + data.pickup_backLeft)
                                }
                              />
                            </div>
                          </div>

                          <div className="col-md-6 mb-3">
                            <div className="car-image-card">
                              <div className="car-image-label">Passanger Right</div>
                              <img
                                src={
                                  carimage + data.pickup_backRight ||
                                  "/placeholder.svg"
                                }
                                alt="Back Right View"
                                className="car-view-img cursor-pointer"
                                onClick={() =>
                                  openImagePreview(carimage + data.pickup_backRight)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr />

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <div className="text-muted mb-2">IPASS Image</div>
                        <img
                          src={carimage + data.ipass_picture || "/placeholder.svg"}
                          alt="IPASS"
                          className="img-thumbnail doc-img cursor-pointer"
                          onClick={() => openImagePreview(carimage + data.ipass_picture)}
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <div className="text-muted mb-2">Key Image</div>
                        <img
                          src={carimage + data.key_image || "/placeholder.svg"}
                          alt="Key"
                          className="img-thumbnail doc-img cursor-pointer"
                          onClick={() => openImagePreview(carimage + data.key_image)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* DOCUMENTS TAB */}
          <div
            className={`tab-pane fade ${activeTab === "documents" ? "show active" : ""
              }`}
          >
            <div className="row g-4">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <Calendar className="icon-sm me-2" />
                      Maintenance Information
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">
                      <div className="text-muted ">Last Maintenance Date</div>
                      <div className="fw-medium">


                        {data?.last_maintenance_date || "NA"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <FileText className="icon-sm me-2" />
                      Vehicle Documentation
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="mb-4">
                      <div className="text-muted ">
                        VIN Number (Last 8 Digits)
                      </div>
                      <div className="fw-medium"> {data?.vin || "NA"}</div>

                    </div>

                    <hr />

                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <div className="text-muted mb-2">Insurance Copy</div>
                        <img
                          src={carimage + data.Insurance_image || "/placeholder.svg"}
                          alt="Insurance"
                          className="img-thumbnail doc-img cursor-pointer"
                          onClick={() =>
                            openImagePreview(carimage + data.Insurance_image)
                          }
                        />
                      </div>

                      <div className="col-md-4 mb-3">
                        <div className="text-muted mb-2">Registration Copy</div>
                        <img
                          src={carimage + data.registration || "/placeholder.svg"}
                          alt="Registration"
                          className="img-thumbnail doc-img cursor-pointer"
                          onClick={() =>
                            openImagePreview(carimage + data.registration)
                          }
                        />
                      </div>

                      <div className="col-md-4 mb-3">
                        <div className="text-muted mb-2">Inspection Copy</div>
                        <img
                          src={carimage + data.inspection || "/placeholder.svg"}
                          alt="Inspection"
                          className="img-thumbnail doc-img cursor-pointer"
                          onClick={() =>
                            openImagePreview(carimage + data.inspection)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FINAL CHECKS TAB */}
          <div
            className={`tab-pane fade ${activeTab === "final" ? "show active" : ""
              }`}
          >
            <div className="row g-4">
              {/* <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <ClipboardCheck className="icon-sm me-2" />
                      Final Checklist
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">
                      {formData.checkedItems.map((item, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center mb-2"
                        >
                          <CheckCircle className="icon-sm me-2 text-success" />
                          <span>{item}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <FileText className="icon-sm me-2" />
                      Additional Notes
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="p-3 bg-light rounded">
                      {data?.notes || "No additional notes provided."}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <Key className="icon-sm me-2" />
                      Form Status
                    </h5>
                    <div className="text-muted small">
                      Overall status of the pickup form submission
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <span className="badge bg-success me-2">Complete</span>
                        <span className="text-muted ">
                          All required fields completed
                        </span>
                      </div>

                      <div>
                        <button className="btn btn-outline-secondary btn-sm me-2" onClick={() => triggerDownloadPDF(data)}>
                          Download
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Image Preview Modal */}
      {previewImage && (
        <div className="preview-modal-overlay" onClick={closeImagePreview}>
          <div
            className="preview-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="preview-modal-close-btn"
              onClick={closeImagePreview}
            >
              <XIcon size={24} />
            </button>
            <img
              src={previewImage}
              alt="Preview"
              className="preview-modal-image"
            />
          </div>
        </div>
      )}
    </div>
  );
}
